import React from 'react';
import { Link } from 'react-router-dom';
import m1 from '../assets/m1.jpeg';
import m2 from '../assets/m2.jpeg';
import m3 from '../assets/m3.jpeg';
import m4 from '../assets/m4.jpeg';
import m5 from '../assets/m5.jpeg';
import m6 from '../assets/m6.jpeg';
import m7 from '../assets/m7.jpeg';

const mediaImages = [m1, m2, m3, m4, m5, m6, m7];

const Media = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="hero-fullwidth h-[400px] md:h-[300px] flex flex-col justify-center px-6 hero-bg-color">
        <h1 className="text-white text-4xl md:text-5xl font-bold">Media</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Media
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-10 px-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Media Gallery</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaImages.map((img, index) => (
            <div key={index} className="overflow-hidden rounded-3xl shadow-lg bg-white">
              <img
                src={img}
                alt={`Media ${index + 1}`}
                className="w-full h-72 object-cover transition-transform duration-500 hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Media;
